export default "__VITE_PUBLIC_ASSET__835412b3__"